export type AgreementBillingPeriod = 'monthly' | 'quarterly' | 'annually';

export interface AgreementTerms {
  pos_system: string | null;
  software_license_fee_amount: number | null;
  software_license_fee_period: AgreementBillingPeriod | null;
}

export interface AgreementTermsInput {
  pos_system?: string | null;
  software_license_fee_amount?: number | null;
  software_license_fee_period?: AgreementBillingPeriod | null;
}

export function normalizeAgreementTerms(input?: AgreementTermsInput | null): AgreementTerms | null {
  if (!input) {
    return null;
  }

  const normalized: AgreementTerms = {
    pos_system: input.pos_system?.trim() || null,
    software_license_fee_amount:
      input.software_license_fee_amount === null || input.software_license_fee_amount === undefined
        ? null
        : Number(input.software_license_fee_amount),
    software_license_fee_period: input.software_license_fee_period ?? null,
  };

  if (
    normalized.pos_system === null &&
    normalized.software_license_fee_amount === null &&
    normalized.software_license_fee_period === null
  ) {
    return null;
  }

  return normalized;
}
